import React from "react";

/**
 * Custom Recharts tooltip that shows dynamic per-mechanic details:
 *  - Usta name
 *  - Points for the given period
 *  - Dynamic share % of the workshop total
 *  - Instant hakediş TL based on the given net pool
 *  - Total job count
 *  - Footer with net_pool + budget for that period
 *
 * Works both as a Recharts tooltip content (receives active/payload) and
 * as a plain data card (pass `row` and it renders without Recharts wiring).
 */
export function MechanicTooltip({ active, payload, row, netPool, totalPoints, budget, header }) {
  const r = row || (active && payload && payload.length ? payload[0].payload : null);
  if (!r) return null;
  const pool = netPool || 0;
  const totalP = totalPoints || 0;
  const dynamicShareRatio = totalP > 0 ? (r.total_points || 0) / totalP : 0;
  const dynamicTL = Math.round(pool * dynamicShareRatio);
  const dynamicPct = dynamicShareRatio * 100;
  return (
    <div
      data-testid="mechanic-tooltip"
      className="bg-white border border-slate-200 rounded-md shadow-xl min-w-[240px] overflow-hidden"
      style={{ fontSize: 12 }}
    >
      <div className="bg-[#1E3A8A] text-white px-3 py-2">
        <div className="text-[9px] uppercase tracking-[0.2em] text-blue-200 font-mono">{header || "Usta"}</div>
        <div className="font-heading font-bold text-sm leading-tight">{r.name || "—"}</div>
      </div>
      <div className="px-3 py-2.5 space-y-2">
        <TooltipRow label="Bu Ay Toplam Puan" value={`${(r.total_points || 0).toLocaleString("tr-TR")} Puan`} mono />
        <TooltipRow label="Atölye İçindeki Payı" value={`%${dynamicPct.toFixed(1)}`} mono accent />
        <TooltipRow label="Anlık Hakediş" value={`₺${dynamicTL.toLocaleString("tr-TR")}`} mono strong />
        <TooltipRow label="Toplam İş Sayısı" value={`${(r.job_count || 0).toLocaleString("tr-TR")}`} mono />
        <div className="pt-1.5 mt-1 border-t border-slate-100 text-[10px] text-slate-500 font-mono leading-snug">
          Kalan güncel havuz: ₺{pool.toLocaleString("tr-TR")} · Toplam bütçe: ₺{(budget || 0).toLocaleString("tr-TR")}
        </div>
      </div>
    </div>
  );
}

export function TooltipRow({ label, value, mono, strong, accent }) {
  return (
    <div className="flex items-center justify-between gap-4">
      <div className="text-[10px] uppercase tracking-widest text-slate-500 font-mono">{label}</div>
      <div className={`${mono ? "font-mono" : ""} ${strong ? "font-bold text-[#1E3A8A] text-sm" : ""} ${accent ? "text-emerald-700 font-semibold" : "text-slate-900"}`}>
        {value}
      </div>
    </div>
  );
}
